module.exports = __webpack_public_path__ + "img/云模型导入.2308c150.svg";